import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { sendRequest, triggerEvent } from '../helpers/global.js';

import SelectInput from './input/SelectInput';
import TextInput from './input/TextInput';

import '../sass/components/ClaimVoucherView.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
  }
};

class ClaimVoucherView extends React.Component {
  constructor(props) {
    super(props);
    const venues = this.props.user?.venues || [];
    this.state = {
      venueId: venues.length === 1 ? venues[0].id : null,
      voucherId: '',
      voucherError: null,
      voucher: null,
    }
  }

  requestVoucher = () => {
    sendRequest({
      method: `user_vouchers/${this.state.voucherId}`,
      type: 'GET',
      data: {
        venue_id: this.state.venueId
      },
      success: (data) => {
        this.setState({voucher: data});
      },
      error: (data) => {
        this.setState({voucherError: data?.errors || 'Not found'});
      }
    });
  }

  claimVoucher = () => {
    sendRequest({
      method: `user_vouchers/${this.state.voucher.code}/claim`,
      type: 'POST',
      data: {
        venue_id: this.state.venueId,
      },
      success: (data) => {
        this.setState({voucher: data});
      },
      error: (data) => {
        triggerEvent('showSnackbar', [{text: data?.errors || 'Not found', type: 'error'}]);
      }
    });
  }

  renderSearchForm = () => {
    const venues = this.props.user?.venues || [];
    return (
      <div className='claimVoucherView'>
        <div className='claimTitle'>Claim a voucher</div>
        {venues.length > 1 ?
          <div className='claimBlock'>
            <div className='blockTitle'>Select an outlet</div>
            <label>Outlet</label>
            <SelectInput
              properties={{
                type: 'select',
                options: venues,
              }}
              object={this.state.venueId}
              onChange={(k, value) => {
                this.setState({venueId: value})
              }}
            />
          </div>
        : null}
        {this.state.venueId ? <>
          <div className='claimBlock'>
            <div className='blockTitle'>Enter voucher details</div>
            <label>Voucher ID</label>
            <TextInput
              properties={{
                type: 'text'
              }}
              object={this.state.voucherId}
              onChange={(k, value) => {
                this.setState({voucherError: null, voucherId: value})
              }}
              error={this.state.voucherError}
              onFocus={() => this.setState({voucherError: null})}
            />
          </div>
          <button
            disabled={!this.state.voucherId}
            onClick={this.requestVoucher}
          >Next</button>
        </> : null}
      </div>
    )
  }

  renderClaimForm = () => {
    const voucher = this.state.voucher;
    const venue = this.props.user.venues.find(i => i.id === this.state.venueId);
    return (
      <div className='claimVoucherView'>
        {voucher.claimed_at
          ? <div className='claimedBlock'>
            <div className='claimedIndicator'/>
            <label>Voucher claimed</label>
          </div>
          : <div
            className='claimTitle withBack'
            onClick={() => this.setState({voucher: null})}
          >Claim a voucher</div>
        }
        <div className='claimBlock'>
          {voucher.claimed_at ? null :
            <div className='blockTitle'>Verify voucher details</div>
          }
          <label>Voucher name</label>
          <div className='voucherValue'>{voucher.voucher.name}</div>
          <label>Outlet claimed</label>
          <div className='voucherValue'>{venue.name}</div>
          <label>Voucher ID</label>
          <div className='voucherValue'>{voucher.code}</div>
          {voucher.claimed_at ? <>
            <label>Date & time</label>
            <div className='voucherValue'>
              {moment.unix(voucher.claimed_at).format('D MMM YYYY · h:mma')}
            </div>
          </> : null}
        </div>
        {voucher.claimed_at
          ? <button
            className='backButton'
            onClick={() => this.setState({voucher: null})}
          >Make another claim</button>
          : <button
            onClick={this.claimVoucher}
          >Claim voucher</button>
        }
      </div>
    )
  }

  render = () => {
    if (this.state.voucher) {
      return this.renderClaimForm();
    } else {
      return this.renderSearchForm();
    }
  }
}

export default connect(mapStoreToProps)(withRouter(ClaimVoucherView));